import React from "react";
import Select from "../../../form/select/Select";

const GeneralInformation = ({
  p_gen_info,
  values,
  errors,
  edit,
  touched,
  handleBlur,
  handleChange,
  setFieldValue,
}) => {
  const Currency = ["NGN"];
  // const { single_policy, isSuccess, isLoading } = useSelector(
  //   (state) => state.policy
  // );
  // const [edit, setEdit] = useState(false);

  // const onSubmit = (values) => {
  //   handleDataSubmit({ ...data, p_general_information: values });
  // };

  // useEffect(() => {
  //   if (p_gen_info) {
  //     setEdit(false);
  //   }
  // }, [p_gen_info]);

  // const {
  //   values,
  //   errors,
  //   handleBlur,
  //   handleChange,
  //   setFieldValue,
  //   handleSubmit,
  //   resetForm,
  //   touched,
  // } = useFormik({
  //   enableReinitialize: true,
  //   initialValues: {
  //     name: p_gen_info?.name || "",
  //     short_name: p_gen_info?.short_name || "",
  //     minimun_duration: p_gen_info?.minimun_duration || "",
  //     currency: p_gen_info?.currency || "",
  //     minimum_age: p_gen_info?.minimum_age || "",
  //     maximum_age: p_gen_info?.maximum_age || "",
  //     description: p_gen_info?.description || "",
  //   },
  //   validationSchema: policyGeneralInfoSchema,
  //   onSubmit,
  //   validate: (values) => {
  //     const errors = {};
  //     if (parseInt(values?.maximum_age) < parseInt(values?.minimum_age)) {
  //       errors.min = "Minimum age cannot be greater than maximum age";
  //       errors.max = "Maximum age cannot be less than minimum age";
  //     }
  //     return errors;
  //   },
  // });

  return (
    <div className='position-relative'>
      <h5 className='text-primary-1 mt-2'>GENERAL INFORMATION</h5>
      <div className='row mt-2'>
        <div className='col-md-4'>
          <div className='mb-3'>
            <label
              htmlFor='policy_name'
              className={`form-label ${edit ? "" : "fw-bolder"}`}
            >
              Name {edit ? <span className='text-danger'>*</span> : null}
            </label>
            {!edit ? <p>{p_gen_info?.policy_name}</p> : null}
            {edit ? (
              <input
                type='text'
                id='policy_name'
                name='policy_name'
                className={`form-control form-control-sm ${
                  errors?.policy_name && touched?.policy_name && "text-danger is-invalid"
                }`}
                value={values?.policy_name}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder='Enter Policy Name'
              />
            ) : null}
            {errors?.policy_name && touched?.policy_name && edit && (
              <span className='text-danger'>{errors?.policy_name}</span>
            )}
          </div>
        </div>
        <div className='col-md-4'>
          <div className='mb-3'>
            <label
              htmlFor='short_name'
              className={`form-label ${edit ? "" : "fw-bolder"}`}
            >
              Short Name {edit ? <span className='text-danger'>*</span> : null}
            </label>
            {!edit ? <p>{p_gen_info?.short_name}</p> : null}
            {edit ? (
              <input
                id='short_name'
                name='short_name'
                value={values?.short_name}
                className={`form-control form-control-sm ${
                  errors?.short_name &&
                  touched?.short_name &&
                  "text-danger is-invalid"
                }`}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder='Enter Short Name'
              />
            ) : null}
            {errors?.short_name && touched?.short_name && edit && (
              <span className='text-danger'>{errors?.short_name}</span>
            )}
          </div>
        </div>
        <div className='col-md-4'>
          <div className='mb-3'>
            <label
              htmlFor='short_name'
              className={`form-label ${edit ? "" : "fw-bolder"}`}
            >
              Currency {edit ? <span className='text-danger'>*</span> : null}
            </label>
            {!edit ? <p>{p_gen_info?.currency}</p> : null}
            {edit ? (
              <Select
                isError={
                  errors?.currency && touched?.currency && !values?.currency
                }
                name='currency'
                data={Currency.map((item, i) => ({
                  label: item,
                  value: item,
                }))}
                value={values.currency}
                onChange={(selectedOption) =>
                  setFieldValue("currency", selectedOption?.value)
                }
                onBlur={() => handleBlur({ target: { name: "currency" } })}
              />
            ) : null}
            {errors?.currency &&
              touched?.currency &&
              !values?.currency &&
              edit && <p className='text-danger mb-0'>{errors?.currency}</p>}
          </div>
        </div>
        <div className='col-md-4'>
          <div className='mb-3'>
            <label
              htmlFor='short_name'
              className={`form-label ${edit ? "" : "fw-bolder"}`}
            >
              Minimum Duration(months){" "}
              {edit ? <span className='text-danger'>*</span> : null}
            </label>
            {!edit ? <p>{p_gen_info?.minimum_duration}</p> : null}

            {edit ? (
              <input
                type='text'
                id='minimum_duration'
                name='minimum_duration'
                className={`form-control ${
                  errors?.minimum_duration &&
                  touched?.minimum_duration &&
                  "text-danger is-invalid"
                }`}
                value={values.minimum_duration}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder='0'
              />
            ) : null}
            {errors?.minimum_duration && touched?.minimum_duration && edit && (
              <span className='text-danger'>{errors?.minimum_duration}</span>
            )}
          </div>
        </div>
        <div className='col-md-4'>
          <div className='mb-3'>
            <label
              htmlFor='short_name'
              className={`form-label ${edit ? "" : "fw-bolder"}`}
            >
              Minimum age
              {edit ? <span className='text-danger'>*</span> : null}
            </label>
            {!edit ? <p>{p_gen_info?.minimum_age}</p> : null}

            {edit ? (
              <input
                type='text'
                id='minimum_age'
                name='minimum_age'
                value={values.minimum_age}
                className={`form-control ${
                  (errors.min || errors?.minimum_age) &&
                  touched?.minimum_age &&
                  "text-danger is-invalid"
                }`}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder='0'
              />
            ) : null}
            {(errors?.minimum_age || errors.min) &&
              touched?.minimum_age &&
              edit && (
                <span className='text-danger'>{errors?.minimum_age}</span>
              )}
            {errors.min && touched?.minimum_age && edit && (
              <span className='text-danger'>{errors.min}</span>
            )}
          </div>
        </div>
        <div className='col-md-4'>
          <div className='mb-3'>
            <label
              htmlFor='short_name'
              className={`form-label ${edit ? "" : "fw-bolder"}`}
            >
              Maximum age
              {edit ? <span className='text-danger'>*</span> : null}
            </label>
            {!edit ? <p>{p_gen_info?.maximum_age}</p> : null}

            {edit ? (
              <input
                type='text'
                id='maximum_age'
                name='maximum_age'
                value={values.maximum_age}
                className={`form-control ${
                  (errors.max || errors?.maximum_age) &&
                  touched?.maximum_age &&
                  "text-danger is-invalid"
                }`}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder='0'
              />
            ) : null}
            {(errors?.maximum_age || errors.max) &&
              touched?.maximum_age &&
              edit && (
                <span className='text-danger'>
                  {errors?.maximum_age || errors.max}
                </span>
              )}
          </div>
        </div>
        <div>
          <div className='col-md-12'>
            <label
              htmlFor='short_name'
              className={`form-label ${edit ? "" : "fw-bolder"}`}
            >
              Description
            </label>
            {!edit ? <p>{p_gen_info?.description}</p> : null}

            {edit ? (
              <textarea
                name='description'
                id=''
                cols='30'
                rows='4'
                value={values?.description}
                className='form-control'
                placeholder='Enter descriprion'
                onChange={handleChange}
                onBlur={handleBlur}
              ></textarea>
            ) : null}
          </div>
          {/* <div className='mt-2 d-flex justify-content-end'>
            {edit ? (
              <>
                <button
                  type='button'
                  className='btn btn-sm btn-secondary  me-2'
                  onClick={() => {
                    setEdit(false);
                    resetForm();
                  }}
                >
                  Close
                </button>
                <button type='submit' className='btn btn-sm btn-success'>
                  Save
                </button>
              </>
            ) : (
              <button
                type='button'
                className='btn btn-sm btn-info'
                onClick={() => setEdit(true)}
              >
                Edit
              </button>
            )}
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default GeneralInformation;
